export enum FormSectionsEnum {
    PersonalDetails = 0,
    EmploymentDetails = 1,
    IncomeDetails = 2,
    StatementDetails = 3,
    PropertyDetails = 4,
    CurrentPropertyDetails = 5,
    NewPropertyDetails = 6,
    BackgroundInformation = 7,
    Declaration = 8,
    CreditReport = 9,
    SupportingInformation = 10,
    PaymentInformation = 11,
}
